import Storage from "./storage";
import { history } from "../shared/configure-store"

class AuthHelper {

    static setLogin = (resp) => {

        Storage.set('access_token', resp.accessToken);

        Storage.set('refresh_token', resp.refreshToken);

        Storage.set('expired_at', resp.expiredAt);

    };

    static setProfile = (resp) => {

        Storage.set('profile', resp);

    };

    static getProfile() {

        return Storage.get('profile');

    };

    static logOut() {

        Storage.clear();

        history.push('/login');

    };

    static isLoggedIn() {

        let temp = Storage.get('profile');

        if(temp){
            if(temp.role){
                return true;
            }
        }
        return false;

    };

}

export default AuthHelper;